export const DUTY_COLUMN_WIDTH = 72;
export const SUM_COLUMN_WIDTH = 84;
